'use client';

import { useContext } from 'react';

import { SettingsContext } from '../contexts/SettingsContext';

import type { SettingsContextProps } from '../@types/settings';

export const useSettings = (): SettingsContextProps => useContext( SettingsContext );
